import axios from 'axios'
import types from './types'

axios.defaults.withCredentials = true

export function getTimezones () {
  return (dispatch) => {
    return dispatch({
      type: types.GET_TIMEZONES,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/timezones/get_all_timezones`)
    }).then(data => data)
  }
}

export function getTimezoneByID (id) {
  return (dispatch) => {
    return dispatch({
      type: types.GET_TIMEZONES,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/timezones/${id}`)
    }).then(data => data)
  }
}
